import React, { useState } from 'react';

import { List, Datagrid, TextField, DeleteButton, Edit, TextInput, Button, Create, SimpleForm, TopToolbar, FormTab, TabbedForm, FormDataConsumer, required, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, Toolbar, SaveButton, useNotify, useRedirect, Filter, downloadCSV } from 'react-admin';import jsonExport from 'jsonexport/dist';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { makeStyles } from '@material-ui/core/styles';

import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';


import { TextFieldShow } from '../components/TextFieldShow';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import GavelIcon from '@material-ui/icons/Gavel';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
  

import { ExportButton } from './../components/ExportButton';

import { Link } from 'react-router-dom';

import { validateMaxLength } from './../components/Validator';export const TicketsZonesList = (props) => {
  const translate = useTranslate();  
    
  let basePath='/tickets_zones'; 
  let resource = 'tickets_zones';
  let strRedirect = 'tickets_zones';
    
  return (
    <ResourceContextProvider value={resource}>
      <List 
        basePath={basePath}   
        filter={{ associations_id : localStorage.getItem('associations_id') }}  
        actions={props.show ?  <span/> : <ListActions />}    
        empty={props.show ?  <span/> : <ListActions />}        
        bulkActionButtons={false}          
        perPage={1000}   
        pagination={false}
        sort={{ field: 'id', order: 'ASC' }} 
        label=""  
        title=""  
        resource={resource}
        filters={props.show ?  <span/> : <MyFilter />} 
        filterDefaultValues={ { q: "" }}
      >        
        <Datagrid 
          rowClick={props.show ? null : 'edit'}
          expand={<TicketsZonesDetails />} >  
          <Avatar><GavelIcon/></Avatar>                                  
          <TextField source="tickets_maps_id" label={translate('tickets_zones.tickets_maps_id')} sortable={false} />  
          <TextField source="name" label={translate('tickets_zones.name')} sortable={false} />  
          <TextField source="access" label={translate('tickets_zones.access')} sortable={false} />  
          <TextField source="capacity" label={translate('tickets_zones.capacity')} sortable={false} />  
        </Datagrid>        
      </List>
    </ResourceContextProvider>
  );
};

const MyFilter = (props) => {
    const translate = useTranslate(); 
    return (
    <Filter {...props}>         
        <TextInput label={translate('common.search')} source="q" alwaysOn validate={[validateMaxLength(50,translate('common.validation.maxLength'))]} resettable />    
    </Filter>
);
};

export const TicketsZonesDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
        
  return (
    <div className="usersClassroomsExpand">        
      <Grid container spacing={2}>
        <Grid item xs={4}>   
          <TextFieldShow source={record.tickets_maps_id} label={translate('tickets_zones.tickets_maps_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.name} label={translate('tickets_zones.name')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.access} label={translate('tickets_zones.access')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.capacity} label={translate('tickets_zones.capacity')} />
        </Grid> 
      </Grid>
      
    </div>
  );
};

const exporter = (items, translate, notify) => {
    
  const itemsForExport = items.map(item => {
    var itemForExport = {
        id: item.id,
        tickets_maps_id: item.tickets_maps_id,
        name: item.name,
        access: item.access,
        capacity: item.capacity,
    };
    return itemForExport;
  });
  jsonExport(itemsForExport, {
    headers: ['id','tickets_maps_id'
,'name'
,'access'
,'capacity'
],
    rename: [translate('common.id'),translate('tickets_zones.tickets_maps_id'),translate('tickets_zones.name'),translate('tickets_zones.access'),translate('tickets_zones.capacity')],        
        
  }, (err, csv) => {
    const csv_new = '\uFEFF' + csv;
    downloadCSV(csv_new, translate('tickets_zones.exporter_file_name') ); 
    notify(translate('common.download_ok'),"success");
  });
};


const ListActions = (props) => {
    const translate = useTranslate(); 
    
    let filterExport = { 
        associations_id: localStorage.getItem('associations_id'),        
        q: props.filterValues && props.filterValues.q ? props.filterValues.q : ''
    };
    
    return (
    <TopToolbar>     
        <MyCreateButton {...props} />    
        <ExportButton maxResults="100000" filterValues={filterExport} alwaysEnabled={false} exporter={exporter} sort={{ field: 'id', order: 'DESC' }} /> 
    </TopToolbar>
    );
};

export const MyCreateButton = ({ users_id , ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('tickets_zones');
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
  const redirect = useRedirect();
        
  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {                    
          redirect('/tickets_zones/' + data.id);
        
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };
    
  return (
    <>            
      <Button onClick={handleClick} label={translate('tickets_zones.create')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('tickets_zones.create')}
      >
        <DialogTitle>{translate('tickets_zones.create')}</DialogTitle>

        <FormWithRedirect
          save={handleSubmit}
          initialValues={{ associations_id: localStorage.getItem('associations_id') }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <Grid container spacing={1}>                                     
                  <Grid item xs={12}>                                               
                    <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid>
                </Grid> 
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const MyActions = ({ basePath, data, resource }) => {

  const translate = useTranslate();   
    
  let linkBack = '/tickets_zones';
        
  return (
    <>
      <TopToolbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>   
            <div style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}>
              <Link
                to={linkBack}
                className=""
              >
                <ArrowBackIosNewIcon className="mr-2" />                        
              </Link>
              <Typography variant="h5" className="grey8">
                {data && data.name ? data.name : null}                    
              </Typography>
            </div>  
                
          </Grid>
        </Grid> 
      </TopToolbar>
    </>
  );
};


export const TicketsZonesEdit  = ({ id, ...props }) => {

  const translate = useTranslate();        
  const classes = useStyles();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  let strRedirect =  `/tickets_zones/${id}`;    
    
  const onSuccess = ({ data }) => {
    notify(translate('common.notification.updated'));        
    redirect('/tickets_zones');        
  };
        
  return (

    <Edit 
      title={<ElementTitle {...props}  />} 
      {...props} 
      id={id}
      mutationMode="pessimistic"
      actions={<MyActions {...props} />}
      onSuccess={onSuccess}   
    >
        
      <TabbedForm        
        toolbar={<FormToolbar />}
      >    
        <FormTab
          label={translate('classrooms.data')}
          contentClassName={classes.tab}
          path="" 
                
        > 
               
          <FormDataConsumer>
            {({ formData, ...rest }) => 
              <>                              
                <br/>
                <Grid container spacing={2}>
                  <Grid item xs={3}>   
            <TextInput fullWidth source="tickets_maps_id" label={translate('tickets_zones.tickets_maps_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="name" label={translate('tickets_zones.name')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="access" label={translate('tickets_zones.access')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="capacity" label={translate('tickets_zones.capacity')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={12}>   
                  </Grid> 
                </Grid>                                

              </>
            }
          </FormDataConsumer>

        </FormTab> 
        
    
      </TabbedForm>
    </Edit>
  );
};

const ElementTitle = ({ record, ...props }) => {    
  const translate = useTranslate(); 
  return (<span>{translate('common.edit')} {record ? `"${record.name}"` : ''}</span>);
};

const FormToolbar = ({ id , ...props }) => {
    
  let redirect = '/tickets_zones';
    
    
  return (
    <Toolbar {...props} className="user_form_toolbar" >
      <SaveButton />
      <DeleteButton redirect={redirect} mutationMode="pessimistic" />
    </Toolbar>
  );
};

const useStyles = makeStyles({
  comment: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tab: {
    maxWidth: '100%',
    display: 'block',
  },
});






export const TicketsZonesCreate  = ({ id, ...props }) => {

  const translate = useTranslate();   
  const [info, setInfo] = useState();
    
  return (

    <Create {...props} >
      <SimpleForm 
        initialValues={{ associations_id: localStorage.getItem('associations_id') }}
        redirect="list"
      >                
        <Grid container spacing={2}>
          <Grid item xs={12}>                    
            <Typography variant="h5" className="grey">{translate('tickets_zones.create')}</Typography>
          </Grid>  
          <Grid item xs={11}>                    
            <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
          </Grid>          
        </Grid>   

      </SimpleForm> 
    </Create>
  );
};
